import axios from '../helpers/axiosConfig';
import React, { useEffect, useState } from 'react';

const PersonnelStatisticsTable = () => {
  const [data, setData] = useState([]);
  const [grades, setGrades] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/statistics/personnelbyserviceandgrade');
        setData(response.data);
        const allGrades = new Set();
        response.data.forEach((service) => {
          Object.keys(service.gradesCount).forEach((grade) => allGrades.add(grade));
        });
        setGrades(Array.from(allGrades));
      } catch (error) {
        console.error('Erreur de chargement :', error);
      }
    };
    fetchData();
  }, []);

  // Total par grade
  const totalParGrade = (grade) =>
    data.reduce((sum, s) => sum + (s.gradesCount[grade] || 0), 0);

  // Total général d'un service
  const totalService = (service) =>
    grades.reduce((sum, g) => sum + (service.gradesCount[g] || 0), 0);

  // Total général
  const totalGeneral = data.reduce((sum, s) => sum + totalService(s), 0);

  return (
    <div className="max-w-7xl mx-auto mt-5 pt-4 px-4">

      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="text-xs font-semibold text-green-600 uppercase tracking-widest mb-1">
            DCCA — Tableau de bord
          </p>
          <h2 className="text-2xl font-bold text-gray-800">
            Statistiques par Service & Grade
          </h2>
        </div>
        <span className="bg-green-100 text-green-800 text-xs font-bold px-4 py-2 rounded-full tracking-wider">
          ACTIF
        </span>
      </div>

      {/* Tableau */}
      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">

            {/* En-tête */}
            <thead>
              <tr className="bg-gray-900">
                <th className="px-5 py-4 text-left text-xs font-semibold text-gray-400 uppercase tracking-widest whitespace-nowrap">
                  Service
                </th>
                {grades.map((grade) => (
                  <th key={grade} className="px-4 py-4 text-center text-xs font-semibold text-gray-400 uppercase tracking-widest whitespace-nowrap">
                    {grade}
                  </th>
                ))}
                <th className="px-4 py-4 text-center text-xs font-semibold text-gray-500 uppercase tracking-widest bg-gray-800">
                  Total
                </th>
              </tr>
            </thead>

            {/* Corps */}
            <tbody>
              {data.map((service, index) => (
                <tr
                  key={service.serviceName}
                  className={`border-b border-gray-100 hover:bg-green-50 transition-colors duration-150 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
                >
                  <td className="px-5 py-4 font-semibold text-gray-800 whitespace-nowrap">
                    <span className="inline-block w-2 h-2 bg-green-500 rounded-full mr-2"></span>
                    {service.serviceName}
                  </td>
                  {grades.map((grade) => (
                    <td key={grade} className="px-4 py-4 text-center">
                      {service.gradesCount[grade] ? (
                        <span className="bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full">
                          {service.gradesCount[grade]}
                        </span>
                      ) : (
                        <span className="text-gray-200">...</span>
                      )}
                    </td>
                  ))}
                  <td className="px-4 py-4 text-center bg-gray-50 font-bold text-gray-800">
                    {totalService(service)}xxxxxxxxxxx
                  </td>
                </tr>
              ))}
            </tbody>

            {/* Pied de tableau */}
            <tfoot>
              <tr className="bg-gray-900">
                <td className="px-5 py-4 text-xs font-bold text-gray-400 uppercase tracking-widest">
                  Total
                </td>
                {grades.map((grade) => (
                  <td key={grade} className="px-4 py-4 text-center text-white font-bold">
                    {totalParGrade(grade)}
                  </td>
                ))}
                <td className="px-4 py-4 text-center bg-green-600 text-white font-bold text-base">
                  {totalGeneral}
                </td>
              </tr>
            </tfoot>

          </table>
        </div>
      </div>

      {/* Légende */}
      <div className="flex gap-4 mt-4 flex-wrap">
        <div className="flex items-center gap-2 text-xs text-gray-500">
          <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full font-bold">N</span>
          Effectif présent
        </div>
        <div className="flex items-center gap-2 text-xs text-gray-500">
          <span className="text-gray-200 font-bold">—</span>
          Aucun effectif
        </div>
      </div>

    </div>
  );
};

export default PersonnelStatisticsTable;